/**
 * Country data loader - fetches and parses the countries JSON file.
 */
import type { CountryData } from '../types';
import { fetchJSON } from '../utils/fetch-data';

let cachedData: CountryData[] | null = null;

export async function loadCountries(): Promise<CountryData[]> {
  if (cachedData) return cachedData;
  cachedData = await fetchJSON<CountryData[]>('/data/countries.json');
  return cachedData;
}
